var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:['block-wrapper', _vm.componentClass, _vm.colorMode, {visible: _vm.visible, ready: _vm.ready}]})}
var staticRenderFns = []

export { render, staticRenderFns }